module.exports = __webpack_public_path__ + "img/level0.7a6c2aa5.7a6c2aa5.svg";